import { LogOut } from 'lucide-react';
import { useEffect } from 'react';
import WorkflowNav from '../../../app/WorkflowNav';
import { STATUS_LABELS } from './kioskConstants';

function joinClasses(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

export function KioskHero({
  className = '',
  sideClassName = '',
  eyebrowClassName = '',
  eyebrow = '',
  title = '',
  loadState,
  connectionStatus = 'connecting',
  showConnectionStatus = false,
  showWorkflowNav = true,
  workflowNavProps,
  avatarLabel = '',
  rightContent = '',
}) {
  const heroClassNames = joinClasses('kiosk-hero', className);
  const heroSideClassNames = joinClasses('kiosk-hero-side', sideClassName);
  const heroEyebrowClassNames = joinClasses('kiosk-eyebrow', eyebrowClassName);
  const logoutHref = workflowNavProps?.logoutHref ?? '/api/auth/logout';
  const logoutLabel = workflowNavProps?.logoutLabel ?? 'ออกจากระบบ';
  const showLogout = workflowNavProps?.showLogout ?? true;
  const profileHref = workflowNavProps?.profileHref ?? '/user-detail';
  const profileLabel = workflowNavProps?.profileLabel ?? 'Open user details';
  const hasMetaRow = Boolean(rightContent || showConnectionStatus || avatarLabel || showLogout);

  useEffect(() => {
    const avatars = document.querySelectorAll('.avatar');

    avatars.forEach((a) => {
      const label = a.dataset.label || 'Avatar';
      const charCodeRed = label.charCodeAt(0);
      const charCodeGreen = label.charCodeAt(1) || charCodeRed;

      const red = Math.pow(charCodeRed, 7) % 200;
      const green = Math.pow(charCodeGreen, 7) % 200;
      const blue = (red + green) % 200;

      a.style.background = `rgb(${red}, ${green}, ${blue})`;
    });
  }, [avatarLabel, rightContent]);

  return (
    <section className={heroClassNames}>
      <div>
        <p className={heroEyebrowClassNames}>{eyebrow}</p>
        <h1>{title}</h1>

        {loadState?.message ? (
          <p className={`kiosk-inline-feedback kiosk-inline-feedback-${loadState.type}`}>{loadState.message}</p>
        ) : null}
      </div>
      <div className={heroSideClassNames}>
        {showWorkflowNav ? (
          <div className="kiosk-hero-nav-row">
            <WorkflowNav {...workflowNavProps} showLogout={false} />
          </div>
        ) : null}
        {hasMetaRow ? (
          <div className="kiosk-hero-meta-row">
            {rightContent}
            {showConnectionStatus ? (
              <div className={`kiosk-status kiosk-status-${connectionStatus}`}>
                <span className="kiosk-status-dot" />
                {STATUS_LABELS[connectionStatus] ?? 'ไม่ระบุ'}
              </div>
            ) : null}
            {showLogout || avatarLabel ? (
              <div className="kiosk-hero-trailing">
                {avatarLabel ? (
                  <a
                    href={profileHref}
                    className="avatar-link"
                    aria-label={profileLabel}
                    title={profileLabel}
                  >
                    <div className="avatar kiosk-hero-avatar" data-label={avatarLabel} />
                  </a>
                ) : null}
                {showLogout ? (
                  <a
                    href={logoutHref}
                    className="workflow-nav-icon-link workflow-nav-logout-icon-link kiosk-hero-logout-btn"
                    aria-label={logoutLabel}
                    title={logoutLabel}
                  >
                    <LogOut size={20} />
                  </a>
                ) : null}
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </section>
  );
}
